<app-attendee-card
  [toptitle]="sportName"
  [title]="title"
  [subtitle]="description"
  [imageSrc]="image"
></app-attendee-card>
